import React, { Fragment } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const PlanDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <td className="text-right pr-5">
                                    {data?.plan?.title ? data?.plan?.title : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Travel Days</th>
                                <td className="text-right pr-5">
                                    {data?.number_of_travel_days ? data?.number_of_travel_days : '-'}
                                </td>
                            </tr>
                             <tr>
                                <th>Insurance Company Name</th>
                                <td className="text-right pr-5">
                                    { data?.Company?.client_company_name ? data?.Company?.client_company_name : '-'}
                                </td>
                            </tr>
                             <tr>
                                <th>Type</th>
                                <td className="text-right pr-5">
                                    {data?.type?.title ? data?.type?.title : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>COA</th>
                                 <td className="text-right pr-5">
                                    {data?.base_premium ? data?.base_premium : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Addons</th>
                                 <td className="text-right pr-5">
                                    {data?.addons_premium ? data?.addons_premium : '-'}
                                </td>
                            </tr>
                             <tr>
                                <th>MSC Percent</th>
                                 <td className="text-right pr-5">
                                    {data?.commission_percent ? `${data?.commission_percent}%`  : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>MSC Amount</th>
                                 <td className="text-right pr-5">
                                    {data?.commission_amount ? data?.commission_amount : '-'}
                                </td>
                            </tr>
                             <tr>
                                <th>GST</th>
                                 <td className="text-right pr-5">
                                    {data?.base_premium ? ((data?.base_premium + data?.addons_premium) * 0.18).toFixed(2) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Member Fee including Tax</th>
                                 <td className="text-right pr-5">
                                    {data?.member_premium ? data?.member_premium : '-'}
                                </td>
                            </tr>
                            {/* <tr>
                                <th>Plan Status</th>
                                <td className="text-right pr-5">
                                    <Badge color={data?.plan?.is_active === true ? 'success' : 'danger'}>
                                        {data?.plan?.is_active ? 'Active' : 'Deactivate'}
                                    </Badge>
                                </td>
                            </tr> */}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default PlanDetails;